import {speculatorT} from '@/lib/types/speculator.types';

import {createDataTableConfig} from '@/lib/helpers/config';

import {DataTable} from '@/components/dataTable';

// TODO: setup navigation to position detail page `/admin/positions/id`
export const SpeculatorDetailPositionsComponent = ({speculator}: {speculator: speculatorT}) => {
  const dataTableConfig = createDataTableConfig({
    table: 'Position',
    columns: ['*'],
    enabled: true,
    columnsDisplay: [
      {header: 'Speculator ID', field: 'fk_speculator_id'},
      {header: 'Factored Cost', field: 'position_factored_price_total'},
      {header: 'Status', field: 'position_status'},
      {header: 'Date Created', field: 'date_created'},
      {header: 'Date Modified', field: 'date_modified'},
    ],
    filters: [{column: 'fk_speculator_id', operator: 'eq', value: speculator.speculator_id}],
    hideAdd: true,
    title: 'Order Summary',
    hideLoading: true,
  });

  return (
    <>
      {/* <StatsRowComponent stats={stats} /> */}
      <DataTable {...dataTableConfig} />
    </>
  );
};
